import React, { useState, useEffect, useRef } from 'react';
import { Drawer, List } from '@mui/material';
import '../styleDrawer.css';
import { Snackbar } from '@mui/material';
import {loadingCableDataComponent, loadingCableTypeDataComponent,
        loadingCouplingDataComponent, loadingFobDataComponent,
        loadingContractorDataComponent,loadingRankCableDataComponent,
        loadingOwnerWellDataComponent, loadingOwnerPillarDataComponent, loadingRankComponentDataComponent} from '../../LoadingData/LoadingDataComponents';
import CustomSnackbar from '../../Components/CustomSnackbar'; 
import { WriteFobHighway, WriteWellHighway, WriteLineOpticHighway, WritePillarHighway, WriteCouplingHighway} from '../../WriteData/WriteHighwayCommunications'; 
import FobContainerSummit from './ContainerEditSummit/FobContainerSummit';
import CouplingContainerSummit from './ContainerEditSummit/CouplingContainerSummit'
import PillarContainerSummit from './ContainerEditSummit/PillarContainerSummit'
import ManholeContainerSummit from './ContainerEditSummit/ManholeContainerSummit'
import CableContainerSummit from './ContainerEditSummit/CableContainerSummit'
import { WritePillarManuallyHighway } from '../../WriteData/WriteHighwayCommunications';
import { CONST_HIGHWAY } from '../../Constants/ConstantsOptics';

const DrawerMenuEditSummit = ({ openEditSummitDrawer, toggleEditSummitDrawer, 
        handleCableSelectChange, handleLineStyleSelectChange, isLineDrawing,
         handleStartDrawing, handleStopDrawing,toggleManholeMarker,manholeMarker,
         togglePillarMarker, pillarMarker, toggleCouplingMarker, couplingMarker,
         toggleFobMarker, fobMarker, coordinatesManhole, setCoordinatesManhole,
         coordinatesPillar, setCoordinatesPillar, coordinatesCoupling, setCoordinatesCoupling,
         coordinatesFob, setCoordinatesFob, coordinatesCableLine, setCoordinatesCableLine, cableOpticId, 
         cableTypeId,highwayRefresh,setLengthCable,lengthCable, user, handleChangeRankComponentFob,
         setSelectedRankFob, selectedRankFob, selectedRankCouling, setSelectedRankCoupling,
         handleChangeRankComponentCoupling, selectedCity, highwayTerritory, selectedCanton, selectedRegoin, selectedArea, cantonCablaByIdRefresh,
         highwayWellRefresh, highwayPillarRefresh, highwayCouplingRefresh, highwayFobRefresh, role}) => {

//#region ПЕРЕМЕННЫЕ

  //Snackbar
  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

  // Кабель 
  const [isVisibleCable, setIsVisibleCable] = useState(false);
  const [cableData, setCableData] = useState([]);
  const [cableTypeData, setCableTypeData] = useState([]);
  const [contractorData, setContractorData] = useState([]);
  const [selectedContractor, setSelectedContractor] = useState(null);
  const [selectedTypeCable, setSelectedTypeCable] = useState(null);
  const [selectedCable, setSelectedCable] = useState([]);
  const commentTextAreaRefCable = useRef(null);
  const [commentCable, setCommentCable] = useState('');
  const [rankCableData, setRankCableData] = useState([]);
  const [selectedRankCable, setSelectedRankCable] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState("Воздушка"); 
  const [isSubway, setIsSubway] = useState(false); 

  // Колодец
  const [isVisibleManhole, setIsVisibleManhole] = useState(false);
  const commentTextAreaRefManhole = useRef(null);
  const [commentManhole, setCommentManhole] = useState('');
  const [ownerWellData, setOwnerWellData] = useState(null);
  const [selectedOwnerWell, setSelectedOwnerWell] = useState([]);

  // Опора 
  const [isVisiblePillar, setIsVisiblePillar] = useState(false);
  const commentTextAreaRefPillar = useRef(null);
  const [commentPillar, setCommentPillar] = useState('');
  const [ownerPillarData, setOwnerPillarData] = useState(null);
  const [selectedOwnerPillar, setSelectedOwnerPillar] = useState([]);
  const [coordinatesManuallyPillae, setCoordinatesManuallyPillae] = useState(''); 
  const [manualInputEnabledPillar, setManualInputEnabledPillar] = useState(false);

  //Муфта
  const [isVisibleCoupling, setIsVisibleCoupling] = useState(false);
  const commentTextAreaRefCoupling = useRef(null);
  const [commentCoupling, setCommentCoupling] = useState('');
  const [couplingData, setCouplingData] = useState([]);
  const [selectedCoupling, setSelectedCoupling] = useState(null);
  const [rankComponentData, setRankComponentData] = useState([])

  //Фоб
  const [isVisibleFob, setIsVisibleFob] = useState(false);
  const commentTextAreaRefFob = useRef(null);
  const [commentFob, setCommentFob] = useState('');
  const [fobData, setFobData] = useState([]);
  const [selectedFob, setSelectedFob] = useState(null);
  
//#endregion  
  
//#region КАБЕЛЬ

useEffect(() => {

  if (selectedGroup === "Подземка") {
    setSelectedContractor(null);
  } else if (selectedGroup) {
    setSelectedContractor(1);
  }
  setSelectedCable([]);
  setSelectedTypeCable(null);
 }, [selectedGroup]);


const handleChangeContractor = (event) => {
  const selectedContractor = event.target.value;
  setSelectedContractor(selectedContractor);
};

const handleChangeRankCable = (event) => {
  const selectedRankCable = event.target.value;
  setSelectedRankCable(selectedRankCable);
};

const handleChangeCableType = (event) => {
  const selectedTypeCable = event.target.value;
  setSelectedTypeCable(selectedTypeCable);
};

// const handleChangeCableSelect = (event) => {
//   const selectedCable = event.target.value;
//   setSelectedCable(selectedCable);
// };

const handleChangeCableSelect = (selectedOption) => {
  if (!selectedOption) {
    // Если пользователь очистил выбор
    setSelectedCable([]);
    return;
  }

  setSelectedCable(selectedOption.value);
};

function toggleVisibilityCable() {
  setIsVisibleCable(!isVisibleCable);
}

const handleCommentChangeCable = (event) => {
  setCommentCable(event.target.value);
}

const handleCableSave = async () => {
   WriteLineOpticHighway( coordinatesCableLine, commentTextAreaRefCable,selectedContractor, cableOpticId, cableTypeId, isLineDrawing, showSnackbar, setCoordinatesCableLine, setCommentCable,
      setSelectedCable,setSelectedTypeCable,setSelectedContractor,highwayRefresh,setLengthCable,lengthCable, setSelectedRankCable,selectedRankCable,  user, cantonCablaByIdRefresh);
    setIsSubway(false);
    };
//#endregion  

//#region КОЛОДЕЦ

function toggleVisibilityManhole() {
  setIsVisibleManhole(!isVisibleManhole);
}

const handleCommentChangeManhole = (event) => {
  setCommentManhole(event.target.value);
}

const handleChangeOwnerWell = (event) => {
  const selectedOwnerWell = event.target.value;
  setSelectedOwnerWell(selectedOwnerWell);
};


async function wellSave(event) {
    WriteWellHighway(event, coordinatesManhole, commentTextAreaRefManhole, selectedCity, manholeMarker, 
                      showSnackbar, setCoordinatesManhole, setCommentManhole,highwayWellRefresh,
                      selectedOwnerWell,setSelectedOwnerWell, user, highwayTerritory);
  }
//#endregion  

//#region ОПОРА
function toggleVisibilityPillar() {
  setIsVisiblePillar(!isVisiblePillar);
}

const handleCommentChangePillar = (event) => {
  setCommentPillar(event.target.value);
}

const handleChangeOwnerPillar = (event) => {
  const selectedOwnerPillar = event.target.value;
  setSelectedOwnerPillar(selectedOwnerPillar);
};

const handleInputChangePillar = (e) => {
  setCoordinatesManuallyPillae(e.target.value || ''); 
};

const toggleManualPillarInput = () => {
  setManualInputEnabledPillar(prev => !prev);
  setCoordinatesManuallyPillae('');
  setSelectedOwnerPillar([]);
  setCommentPillar('');
};

async function pillarSave(event) {
    WritePillarHighway(event, coordinatesPillar, commentTextAreaRefPillar, selectedCity, pillarMarker,
                       showSnackbar, setCoordinatesPillar, setCommentPillar,highwayPillarRefresh,
                        selectedOwnerPillar,setSelectedOwnerPillar, user,highwayTerritory);
  }

  async function  pillarManuallySave (event) {
     const coords = coordinatesManuallyPillae.split(',').map(coord => parseFloat(coord.trim()));    
         if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
              
            WritePillarManuallyHighway(event, coords[0], coords[1], selectedCity, user, commentTextAreaRefPillar, selectedOwnerPillar,
              highwayPillarRefresh, setCoordinatesManuallyPillae, showSnackbar, selectedCity, CONST_HIGHWAY );
    
         } else {
           showSnackbar(`Введите корректные координаты в формате "50.4488, 30.5255"`, 'snackbarWarning');
         }
  }
//#endregion

//#region МУФТА
function toggleVisibilityCoupling() {
  setIsVisibleCoupling(!isVisibleCoupling);
}

const handleCommentChangeCoupling = (event) => {
  setCommentCoupling(event.target.value);
}

const handleChangeCoupling = (event) => {
  const selectedCoupling = event.target.value;
  setSelectedCoupling(selectedCoupling);
};

async function couplingSave(event) {
  WriteCouplingHighway(event, coordinatesCoupling, selectedCoupling, commentTextAreaRefCoupling, 
                      selectedCity, couplingMarker, showSnackbar, setCoordinatesCoupling, 
                      setCommentCoupling, highwayCouplingRefresh,setSelectedCoupling,
                      selectedRankCouling, setSelectedRankCoupling, user,highwayTerritory);
}
//#endregion

//#region ФОБ
function toggleVisibilityFob() {
  setIsVisibleFob(!isVisibleFob);
}

const handleCommentChangeFob = (event) => {
  setCommentFob(event.target.value);
}

const handleChangeFob = (event) => {
  const selectedFob = event.target.value;
  setSelectedFob(selectedFob);
};

async function fobSave(event) {
  WriteFobHighway(event, coordinatesFob, selectedFob, commentTextAreaRefFob, selectedCity, fobMarker,
                  showSnackbar, setCoordinatesFob, setCommentFob,highwayFobRefresh,
                  setSelectedFob,selectedRankFob, setSelectedRankFob, user, highwayTerritory);
}
//#endregion

//#region ЗАГРУЗКА ДАННЫХ
useEffect(() => {
  const fetchData = async () => {
    try {
      const [
        cableData,
        cableTypeData,
        couplingData,
        fobData,
        contractorData,
        rankComponentData,
        rankCableData,
        ownerWellData,
        ownerPillarData,
      ] = await Promise.all([
        loadingCableDataComponent(),
        loadingCableTypeDataComponent(),
        loadingCouplingDataComponent(),
        loadingFobDataComponent(),
        loadingContractorDataComponent(),
        loadingRankComponentDataComponent(),
        loadingRankCableDataComponent(),
        loadingOwnerWellDataComponent(),
        loadingOwnerPillarDataComponent(),
      ]);

      // Установка данных
      setCableData(cableData);
      setCableTypeData(cableTypeData);
      setCouplingData(couplingData);
      setFobData(fobData);
      setContractorData(contractorData);
      setRankComponentData(rankComponentData);
      setRankCableData(rankCableData);
      setOwnerWellData(ownerWellData);
      setOwnerPillarData(ownerPillarData);
    } catch (error) {
      console.error("Ошибка при загрузке данных:", error);
    }
  };

  fetchData();
}, []);
//#endregion
 
  return (
    <Drawer
      open={openEditSummitDrawer}
      onClose={toggleEditSummitDrawer(false)}
      PaperProps={{ className: 'drawerBackground hideScrollbar' }}     
    >
      <div className="divTitleDrawer">
            <p className='textTitleDrawer'>Режим внесения</p>
            <p className='textTitleDrawer'>Ранг 1/2</p>
      </div>
      <List  >
        <div className='divBodyDrawer'>
          <p className='textTitleDrawer'>Оптоволоконный кабель</p>
          {/* Кабель */}
            <CableContainerSummit
              toggleVisibilityCable={toggleVisibilityCable}
              isVisibleCable={isVisibleCable}
              cableData={cableData}
              handleCableSelectChange={handleCableSelectChange}
              cableTypeData={cableTypeData}
              handleLineStyleSelectChange={handleLineStyleSelectChange}
              contractorData={contractorData}
              selectedContractor={selectedContractor}
              handleChangeContractor={handleChangeContractor}
              commentCable={commentCable}
              commentTextAreaRefCable={commentTextAreaRefCable}
              handleCommentChangeCable={handleCommentChangeCable}
              isLineDrawing={isLineDrawing}
              handleStartDrawing={handleStartDrawing}
              handleStopDrawing={handleStopDrawing}
              handleCableSave={handleCableSave}
              handleChangeCableType={handleChangeCableType}
              selectedTypeCable={selectedTypeCable}
              handleChangeCableSelect={handleChangeCableSelect}
              selectedCable={selectedCable}
              rankCableData={rankCableData}
              handleChangeRankCable={handleChangeRankCable}
              selectedRankCable={selectedRankCable}
              selectedGroup={selectedGroup}
              setSelectedGroup={setSelectedGroup}
              isSubway={isSubway}
              setIsSubway={setIsSubway}
              role={role}
              setSelectedContractor={setSelectedContractor}
            />
          </div>

        <div className="divBodyDrawer">
          <p className='textTitleDrawer'>Коммуникации</p>

              {/* Колодец */}
              <ManholeContainerSummit
                 toggleVisibilityManhole={toggleVisibilityManhole}
                 isVisibleManhole={isVisibleManhole}
                 commentManhole={commentManhole}
                 commentTextAreaRefManhole={commentTextAreaRefManhole}
                 handleCommentChangeManhole={handleCommentChangeManhole}
                 toggleManholeMarker={toggleManholeMarker}
                 manholeMarker={manholeMarker}
                 wellSave={wellSave}
                 ownerWellData={ownerWellData}
                 handleChangeOwnerWell={handleChangeOwnerWell}
                 selectedOwnerWell={selectedOwnerWell}
              />

              {/* Опора */}
              <PillarContainerSummit
                  toggleVisibilityPillar={toggleVisibilityPillar}
                  isVisiblePillar={isVisiblePillar}
                  commentPillar={commentPillar}
                  commentTextAreaRefPillar={commentTextAreaRefPillar}
                  handleCommentChangePillar={handleCommentChangePillar}
                  togglePillarMarker={togglePillarMarker}
                  pillarMarker={pillarMarker}
                  pillarSave={pillarSave}
                  ownerPillarData={ownerPillarData}
                  handleChangeOwnerPillar={handleChangeOwnerPillar}
                  selectedOwnerPillar={selectedOwnerPillar}
                  pillarManuallySave={pillarManuallySave}
                  handleInputChangePillar={handleInputChangePillar}
                  coordinatesManuallyPillae={coordinatesManuallyPillae}
                  toggleManualInput={toggleManualPillarInput}
                  manualInputEnabledPillar={manualInputEnabledPillar}
              />

              {/* Муфта */}
              <CouplingContainerSummit
                toggleVisibilityCoupling={toggleVisibilityCoupling}
                isVisibleCoupling={isVisibleCoupling}
                handleChangeCoupling={handleChangeCoupling}
                selectedCoupling={selectedCoupling}
                couplingData={couplingData}
                commentCoupling={commentCoupling}
                commentTextAreaRefCoupling={commentTextAreaRefCoupling}
                handleCommentChangeCoupling={handleCommentChangeCoupling}
                toggleCouplingMarker={toggleCouplingMarker}
                couplingMarker={couplingMarker}
                couplingSave={couplingSave}
                rankComponentData={rankComponentData}
                handleChangeRankComponentCoupling={handleChangeRankComponentCoupling}
                selectedRankCouling={selectedRankCouling}
              />  

              {/* Фоб */}
              <FobContainerSummit
                toggleVisibilityFob={toggleVisibilityFob}
                isVisibleFob={isVisibleFob}
                handleChangeFob={handleChangeFob}
                selectedFob={selectedFob}
                fobData={fobData}
                commentFob={commentFob}
                commentTextAreaRefFob={commentTextAreaRefFob}
                handleCommentChangeFob={handleCommentChangeFob}
                toggleFobMarker={toggleFobMarker}
                fobMarker={fobMarker}
                fobSave={fobSave}
                rankComponentData={rankComponentData}
                handleChangeRankComponentFob={handleChangeRankComponentFob}
                selectedRankFob={selectedRankFob}
              />
        </div>
      </List>
       
      {/* Snackbar */}
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        ContentProps={{
          style: {
            backgroundColor: snackbarClass === 'snackbarWarning' ? 'rgb(235, 235, 187)' : 'rgb(193, 255, 174)',
            color: 'black'
          }
        }}
      />
    </Drawer>    
  );
};

export default DrawerMenuEditSummit;